// extracted by mini-css-extract-plugin
export var actions = "_mi-5";
export var assistantBubble = "_mi-3";
export var assistantRow = "_mi-6";
export var bubble = "_mi-0";
export var humanAvatar = "_mi-4";
export var inlineToolCard = "_mi-1";
export var userBubble = "_mi-2";